export default __webpack_public_path__ + "static/media/fireflink_force.87cb6199.svg";